import { EVENT_CLOSE, EVENT_ERROR } from "manifest-bridge-core/src/events";
import { ErrorCode } from "../typings";
import { resetSentryUser } from "../lib/sentry";
import generateURIRedirect from "./generateURIrefirect";

export type ErrorParams = {
  errorCode: ErrorCode;
  errorMessage: string;
};

const sendError = (data: ErrorParams, isWebview: boolean) => {
  resetSentryUser();
  if (isWebview) {
    const redirectURI = generateURIRedirect({ event: EVENT_ERROR, errorData: data });
    window.location.href = redirectURI;
  } else {
    window.parent.postMessage(
      {
        type: EVENT_ERROR,
        data,
      },
      "*",
    );
    window.parent.postMessage(
      {
        type: EVENT_CLOSE,
      },
      "*",
    );
  }
};

export default sendError;
